import { RegisterTypes } from 'src/app/accounts/enums/register-types.enums';
import { OnboardingIntentStep } from 'src/app/shared/enums/intent.enum';
import { OnboardingPaths } from 'src/app/shared/interfaces/intent.interface';

const ADRIALAB_STEPS: OnboardingPaths = {
  [OnboardingIntentStep.Welcome]: { path: '/onboarding/adrialab/welcome' },
  [OnboardingIntentStep.Register]: {
    path: '/accounts/create',
    queryParams: {
      type: RegisterTypes.LAB_ADRIALAB,
    },
  },
  [OnboardingIntentStep.Newsletter]: { path: '/accounts/newsletters' },
  [OnboardingIntentStep.Caution]: { path: '/accounts/caution' },
  [OnboardingIntentStep.Check]: { path: '/accounts/verify' },
  [OnboardingIntentStep.Login]: { path: '/accounts/check' },
  [OnboardingIntentStep.Onboarding]: { path: '/onboarding/details' },
  [OnboardingIntentStep.PushNotifications]: {
    path: '/onboarding/push-notifications',
  },
  [OnboardingIntentStep.Claim]: { path: '/onboarding/adrialab/details' },
  [OnboardingIntentStep.Complete]: { path: '/onboarding/adrialab/complete' },
  [OnboardingIntentStep.DownloadAfterCheck]: { path: '/onboarding/download' },
  [OnboardingIntentStep.End]: { path: '/dashboard' },
};

export default ADRIALAB_STEPS;
